import PeopleWithHeart from "./people-with-heart.svg";

export default PeopleWithHeart;
